import React from "react";

const PeseeQuotaCard = ({ quota }) => {
  const quotaNumber = quota?.quotaNumber;
  const totalInscrits = quota?.totalInscrits || 0;
  const ratio = quota?.ratio || 0;

  if (!quotaNumber || quotaNumber <= 0) return null;

  const exceeded = totalInscrits > quotaNumber;
  const almostFull = !exceeded && ratio > 0.8;

  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white/80 px-4 py-3 shadow-sm backdrop-blur dark:border-white/10 dark:bg-slate-900/80 lg:max-w-sm">
      <p className="mb-1 text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
        Capacité
      </p>

      <div className="mb-2 flex items-baseline justify-between gap-2">
        <span className="text-sm font-bold text-slate-800 dark:text-slate-100">
          {totalInscrits} / {quotaNumber} inscrit{quotaNumber > 1 ? "s" : ""}
        </span>

        <span
          className={`text-xs font-bold ${
            exceeded
              ? "text-rose-500"
              : almostFull
              ? "text-amber-500"
              : "text-emerald-500"
          }`}
        >
          {exceeded
            ? "Quota dépassé"
            : almostFull
            ? "Bientôt complet"
            : "Places disponibles"}
        </span>
      </div>

      <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
        <div
          className={`h-full rounded-full transition-all duration-300 ${
            exceeded
              ? "bg-rose-500"
              : almostFull
              ? "bg-amber-400"
              : "bg-emerald-500"
          }`}
          style={{
            width: `${Math.min(100, (totalInscrits / quotaNumber) * 100)}%`,
          }}
        />
      </div>
    </div>
  );
};

export default PeseeQuotaCard;